module.exports = __webpack_public_path__ + "img/20210610-IMG_05091.57391a54.jpg";